import React, { useState, useEffect } from "react";
import Row from "../../../components/Row";
import Dropdown from "../../../components/FormFields/Dropdown";
import Select from 'react-select';
import Icon from 'react-web-vector-icons';
import Spacer from "../../../components/Spacer";
import { isNullOrEmpty } from "../../../utils/general";

import aws_adoption from '../../../utils/collections/aws_adoption';
import aws_segment from '../../../utils/collections/aws_segment';
// import geo from '../../../utils/collections/geo';
import greenfield_engaged from '../../../utils/collections/greenfield_engaged';

import billing_country from '../../../utils/collections/billing_country';
import company_size from '../../../utils/collections/company_size';
import industries from '../../../utils/collections/industries';

// import ms_areaname from '../../../utils/collections/ms_region.json';
import ms_industries from '../../../utils/collections/ms_industries';
import ms_region from '../../../utils/collections/ms_region';
import ms_segment from '../../../utils/collections/ms_segment';
import ms_segment_group from '../../../utils/collections/ms_segment_group';
import * as staticData from '../../../redux/staticData/actions';
import { useDispatch } from 'react-redux';
import './QueryRow.scss';
import { returnParsedColumnName } from "../../../utils/columns";
import LoadingClock from "../../../components/LoadingClock";
import log from "loglevel";


const QueryRow = props => {
	const [dropdownData, setDropdownData] = React.useState(null);
	const getDropdownValuesByField = field => {
		if (!dropdownData) return;
		switch (field) {
			case 'industry_id':
				return dropdownData.industry;
			case 'aws_subsidiary_id':
				return dropdownData.country.map((c) => c.name);
				case 'hq_id':
					return dropdownData.country;	
			case 'employees':
				return dropdownData.companySize;
			// case 'geo':
			// 	return geo;
			case 'aws_segment_id':
				return dropdownData.awsSegment;
			case 'aws_adoption_id':
				return dropdownData.adoption;
			case 'engaged_greenfield':
				return greenfield_engaged;
			// case 'AreaName':
			// 	return ms_areaname;
			case 'region_id':
				return dropdownData.region;
			case 'microsoft_segment_group_id':
				return dropdownData.segmentGroup;
			case 'microsoft_subsegment_id':
				return dropdownData.subSegment;
		}

		return null;
	};

	const { row, vendor, showDelete, onChange, onDelete, onAdd } = props;
	const [checkErrors, setCheckErrors] = useState(row.checkErrors);
	const [field, setField] = useState(row.field);
	const [modifiedDropdownData, setModifiedDropdownData] = useState(null);
	const [type, setType] = useState(row.type);
	const [value, setValue] = useState(row.value);
	const [loading, setLoading] = useState(false);
	const hash = JSON.stringify(row);
	const dispatch = useDispatch();

	useEffect(() => {
		setLoading(true);
		dispatch(staticData.loadStaticData((data) => {
			setDropdownData(data);
			setLoading(false);
		}));
	}, []);

	useEffect(() => {
		const load = async () => {
			setCheckErrors(row.checkErrors);
		};
		load();
	}, [row.checkErrors]);

	useEffect(() => {
		if (!dropdownData) return; // Wait until data is loaded
		const updated = getDropdownValuesByField(row.field);
		    setField(row.field);
			setType(row.type);
			setValue(row.value);

		setModifiedDropdownData(updated);
	}, [dropdownData, row.field]);
	
	// if (!dropdownData) return null;

	const topFieldOption = { key: '', label: 'Select Field' };

	const types = [
		{ key: 'exact', label: 'Is Exactly' },
		{ key: 'is_not', label: 'Is Different From' },
		{ key: 'contains', label: 'Contains' },
		{ key: 'starts_with', label: 'Starts With' },
		{ key: 'ends_with', label: 'Ends With' }
	];

	const dropdownTypes = [
		{ key: 'exact', label: 'Is Exactly' },
		{ key: 'is_not', label: 'Is Different From' }
	];

	const updateField = field => {
		setField(field);
		row.field = field;

		setValue('');
		row.value = '';

		let type = '';
		const customDropdown = getDropdownValuesByField(field);

		if (customDropdown || isNullOrEmpty(type)) {
			type = 'exact';
		}

		setType(type);
		row.type = type;

		setModifiedDropdownData(customDropdown);
		if (customDropdown) {
			// initialize as empty array for multi-select-backed fields
			row.value = [];
		}
		onChange(row);
	};

	const updateType = type => {
		setType(type);
		row.type = type;
		onChange(row);
	};

	const updateValue = value => {
		setValue(value);
		row.value = value;
		onChange(row);
	};

	const isValid = fld => {
		return checkErrors && isNullOrEmpty(fld) ? 'red' : '#6A8991';
	};

	let columns, fields;
	if (vendor === 'aws') {
		columns = [
			'aws_account_name',
			'hq_id',
			'region_id',
			'subsidiaries',
			'industry_id',
			'address',
			'employees',
			'website',
			'engaged_greenfield',
			// 'aws_account_id',
			// 'linkedin_followers',
			// 'account_description',
			// 'specialties',
			// 'organization_type_id',
			// 'crunchbase_url',
			// 'founded',
			// 'company_linkedin_id',
			// 'city',
			// 'state_id',
			// 'linkedin_url',
			// 'logo',
			// 'similar_accounts',
			// 'updates',
			// 'slogan',
			// 'affiliates',
			// 'funding',
			// 'investors',
			// 'us_district_id',
			// 'initial_source',
			// 'timestamp',
			// 'latest_source',
			// 'decision_making',
			// 'presence',
			// 'installed_isv_technologies',
			// 'installed_enterprise_technologies',
			// 'installed_infra_providers',
			// 'installed_developer_tools',
			// 'aws_name',
			// 'aws_subsidiary_id',
			'aws_segment_id',
			// 'aws_sub_segment_id',
			// 'aws_partner_id',
			// 'partner_type_id',
			// 'isv_accelerate_id',
			// 'ace_eligible_id',
			// 'saas_revenue_recognition_id',
			// 'aws_marketplace_status_id',
			// 'aws_adoption_id',
			// 'aws_relationship_strength_id',
			// 'aws_main_contact_id',
			// 'aws_services',
			// 'aws_code',
			// 'fortune_num',
			// 'duns_num',
			// 'is_priority',
			// 'data_import_id'
		];
	}
	else {
		columns = [
			'ms_account_name',
			'hq_id',
			'region_id',
			'subsidiaries',
			'industry_id',
			'address',
			'employees',
			'website',
			// 'specialties',
			// 'AccountTechnologyLeadAlias',
			// 'ms_account_id',
			// 'linkedin_followers',
			// 'account_description',
			// 'organization_type_id',
			// 'crunchbase_url',
			// 'founded',
			// 'company_linkedin_id',
			// 'city',
			// 'state_id',
			// 'linkedin_url',
			// 'logo',
			// 'similar_accounts',
			// 'updates',
			// 'slogan',
			// 'affiliates',
			// 'funding',
			// 'investors',
			// 'us_district_id',
			// 'microsoft_name',
			// 'ms_subsidiary_id',
			// 'microsoft_segment_group_id',
			// 'microsoft_subsegment_id',
			// 'microsoft_partner_id',
			// 'ip_cosell_id',
			// 'pr-acr_id',
			// 'top-tier_id',
			// 'microsoft_marketplace_status_id',
			// 'macc_eligible_id',
			// 'azure_adoption_id',
			// 'microsoft_relationship_strength_id',
			// 'microsoft_main_contact_id',
			// 'microsoft_services',
			// 'initial_source',
			// 'timestamp',
			// 'latest_source',
			// 'decision_making',
			// 'presence',
			// 'installed_isv_technologies',
			// 'installed_enterprise_technologies',
			// 'installed_infra_providers',
			// 'installed_developer_tools',
			// 'microsoft_tags',
			// 'fortune_num',
			// 'duns_num',
			// 'is_priority',
			// 'data_import_id'
		];
	}
	fields = columns.map(c => ({ key: c, label: returnParsedColumnName(c) }));
	if(loading) return <LoadingClock />;

	// react-select styles to match Manual Search UI
	const selectStyles = {
		control: (provided) => ({
			...provided,
			minWidth: '250px',
			width: 'fit-content',
			maxWidth: '600px',
			borderRadius: '6px',
			border: `1px solid ${isValid(type)}`,
			outline: 'none',
			padding: '0 5px'
		})
	};

	const toOptions = (arr) => {
		if(!arr) return [];
		return arr.map(item => typeof item === 'object' ? { value: item.id, label: item.name } : { value: item, label: item });
	};

	const options = toOptions(modifiedDropdownData);
	const selectedOptions = Array.isArray(value) ? value.map(v => options.find(o => `${o.value}` === `${v}`)).filter(Boolean) : [];
	return (
		<Row className="query-row-container">
			<Dropdown style={{ borderColor: isValid(field) }} items={fields} onChange={updateField} selectedValue={field} keyField="key" labelField="label" topOption={topFieldOption} />
			<Spacer s={18} />

			{
				modifiedDropdownData ?
					<Dropdown items={dropdownTypes} onChange={updateType} selectedValue={type} keyField="key" labelField="label" />
					:
					<Dropdown items={types} onChange={updateType} selectedValue={type} keyField="key" labelField="label" />
			}
			<Spacer s={18} />

			<div>
			{
					modifiedDropdownData ?
						<Select closeMenuOnSelect={false} styles={selectStyles} isMulti options={options} value={selectedOptions} onChange={(opts) => updateValue((opts || []).map(o => o.value))} placeholder="Select..." />
						:
						<input onChange={e => updateValue(e.target.value)} value={value} className="query-row-input" style={{ minWidth: '230px', width: '230px', borderColor: isValid(value) }} />
				}
			</div>

			<Spacer s={14} />
			<div style={{ width: '40px', display: 'flex', justifyContent: 'space-between' }}>
				{showDelete && (
					<div style={{ cursor: 'pointer' }} onClick={onDelete}>
						<Icon name="trash-2" font="Feather" color="#6A8991" size={18} />
					</div>
				)}
			</div>

		</Row>
	)
};

export default QueryRow;
